/**
 * @module: 招聘模块公用数据
 * @author: xiongsha
 * @date: 2019-10-31 11:27:20
 */

import { observable, action, flow } from 'mobx';
import { ajax, utils } from '@clouderwork/ywk';
import { IUserInfo, IBaseData, ISendMessagePrams, ITech } from '../../entity/user';
import { urlFn } from '@src/utils/index';
import { Toast } from 'antd-mobile';
import { withRole } from '@src/utils/residentNew';
import Axios from 'axios';
import { toLogin } from '@src/utils/helper';
import { config } from 'react-spring';


/**
 * 首页和搜索页共用定位记录
 */
export const LOCATION_HISTORY = 'zhaopin-location-history';

class User {
  // 当前用户信息
  @observable curUserInfo: IUserInfo | undefined;
  @observable baseData: IBaseData = {};
  @observable baseCityList: IBaseData[] = [];
  @observable baseLoading: boolean = false
  @observable technologies: ITech[] = [];

  constructor() {
    const flag = urlFn.getFirstPathName();
    if (flag !== 'zhaopin') return;
    console.log('zhaopin user constructor')
    // Axios.interceptors.response.use(data => {
    //   console.log('axios data', data);

    //   if(data.status === 403) {
    //     toLogin()
    //   }
    //   return Promise.resolve(data)
    // }, err => {
    //   console.log('axios err', err);
    //   return Promise.reject(err);
    // });
    this.getProfile();
    this.getBasicData();
    this.getCity();
    // axios增加拦截器
  }

  /**
   * 获取用户信息
   *
   * @returns
   * @memberof User
   */
  @action.bound
  async getProfile(platform: string = '') {
    this.baseLoading = true
    const res = await ajax.getJson('/zhaopin/api/user', withRole({}));
    this.baseLoading = false
    console.log('res', res.arg, res.config, res.response);
    if (res.error_code === 0) {
      this.curUserInfo = res.user
    } else {
      if(res.response.status === 403 || (res.response.data && +res.response.data.error_code === 80001)) {
        toLogin()
      }
    }
  }
  // 储存公用常量数据
  @action.bound
  async getBasicData() {
    const res = await ajax.getJson('/zhaopin/api/params', withRole({}))
    if (res.error_code === 0) {
      this.baseData = res.params
    }
  }
  // 获取城市数据
  @action.bound
  async getCity() {
    const res = await ajax.getJson('/zhaopin/api/citys', withRole({}))
    if (res.error_code === 0) {
      this.baseCityList = res.citys
    }
  }

  // 向沃客信发送消息
  @action.bound
  async sendMessage(params: ISendMessagePrams, isPerson = false) {
    let str = '';
    if(!isPerson) {
      str = 'usergroup_id=' + `${this.curUserInfo ? this.curUserInfo.company_uuid : ''}`;
    }
    return await ajax.post(
      `/wokexin/api/v1/message.send?${str}`,
      params
    );
  }
  // 获取职能数据
  @action.bound
  getTechnologies = flow(function* (this: User) {
    try {
      const res = yield ajax.getJson('/resident/api/technologies', withRole({}));
      if (res.error_code === 0) {
        this.technologies = res.technologies;
      }
    } catch (error) {
      Toast.fail('请求失败');
    }
  })

}

export default User;
